module.exports = __webpack_public_path__ + "static/media/pinGray.6839f299.svg";